import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["assetFileStatus"],
  _excluded2 = ["fileStatus"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect, useState } from 'react';
import useFetchFileStatus from './useFetchFileStatus';
import { FILE_STATUS_VALUES } from './constants';
function useProcessingFileStatus(_ref) {
  var assetFileStatus = _ref.assetFileStatus,
    otherOptions = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFileProcessing = _useState2[0],
    setIsFileProcessing = _useState2[1];
  var _useFetchFileStatus = useFetchFileStatus(_objectSpread({
      enabled: isFileProcessing
    }, otherOptions)),
    _useFetchFileStatus$f = _useFetchFileStatus.fileStatus,
    fileStatus = _useFetchFileStatus$f === void 0 ? assetFileStatus : _useFetchFileStatus$f,
    rest = _objectWithoutProperties(_useFetchFileStatus, _excluded2);
  useEffect(function () {
    if (fileStatus === FILE_STATUS_VALUES.READY || fileStatus === FILE_STATUS_VALUES.INVALID || fileStatus === FILE_STATUS_VALUES.DRAFT) {
      setIsFileProcessing(false);
    } else {
      setIsFileProcessing(true);
    }
  }, [fileStatus]);
  var isProcessingStatusShowing = fileStatus === FILE_STATUS_VALUES.PROCESSING || fileStatus === FILE_STATUS_VALUES.DRAFT || fileStatus === FILE_STATUS_VALUES.INVALID;
  return _objectSpread({
    fileStatus: fileStatus,
    isProcessingStatusShowing: isProcessingStatusShowing
  }, rest);
}
export default useProcessingFileStatus;